<template>
  <vs-popup 
    class="sos-reason-popup"
    :title="isEdit ? 'Edit Reason' : 'Create Reason'"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          
          <!-- Reason Input -->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <ValidationProvider name="reason" rules="required" v-slot="{ errors }">
                <vs-input
                  v-model="formData.reason"
                  label="Reason"
                  placeholder="Enter reason"
                  class="w-full"
                  :danger="errors.length > 0"
                />
                <span class="text-danger text-sm" v-if="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="vx-row">
            <div class="vx-col w-full flex justify-end">
              <vs-button 
                color="danger" 
                type="border" 
                class="mr-3"
                @click="open = false"
              >
                Cancel
              </vs-button>
              <vs-button 
                color="primary" 
                type="filled"
                button="submit"
              >
                {{ isEdit ? 'Update' : 'Create' }}
              </vs-button>
            </div>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')

export default {
  data() {
    return {
      open: false,
      isEdit: false,
      reasonId: null,
      formData: {
        reason: ''
      }
    }
  },
  methods: {
    openPopup(reason = null) {
      if (reason) {
        // Edit mode
        this.isEdit = true
        this.reasonId = reason.id
        this.formData.reason = reason.reason
      } else {
        // Create mode
        this.isEdit = false
        this.reasonId = null
        this.formData.reason = ''
      }
      this.open = true
    },

    async onSubmit() {
      try {
        if (this.isEdit) {
          await CustomerRepository.updateSosChangeReason(this.reasonId, this.formData)
          this.$vs.notify({
            title: 'Success',
            text: 'Reason updated successfully',
            color: 'success'
          })
        } else {
          await CustomerRepository.createSosChangeReason(this.formData)
          this.$vs.notify({
            title: 'Success',
            text: 'Reason created successfully',
            color: 'success'
          })
        }
        
        this.open = false
        this.$emit('saved')
        this.resetForm()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to save reason',
          color: 'danger'
        })
      }
    },

    resetForm() {
      this.formData = {
        reason: ''
      }
      this.$refs.form.reset()
    }
  }
}
</script>